import React, { Component } from 'react'
import PropTypes from 'prop-types'

class LinkHack extends Component {
  render () {
    const {element_type} = this.props

    return (
      <a {...this.props}
         href={this.props.to}>
        {this.props.children}
      </a>
    )
  }
}

LinkHack.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node
}

export default LinkHack



// WEBPACK FOOTER //
// ./src/components/LinkHack.js